export default {
	bootstrapHelpers: {
		uncollapseMatchedPanel: ($matchedElement) => {
			pp.bootstrapHelpers.showBootstrapPanelInstantly(
				$matchedElement.parents(".panel-collapse").attr("id"),
			);
		},
		hideBootstrapPanelsInContainerInstantly: ($container) => {
			$container.find(".panel-collapse").removeClass("in").addClass("collapse");
			$container
				.find('[data-toggle="collapse"]')
				.attr("aria-expanded", "false")
				.addClass("collapsed");
		},
		showBootstrapPanelsInContainerInstantly: ($container) => {
			$container
				.find(".panel-title")
				.attr("aria-expanded", "true")
				.removeClass("collapsed");
			$container.find(".panel-collapse").removeClass("collapse");
		},
		showBootstrapPanelInstantly: (panelId) => {
			const $trigger = $(`[data-target="#${panelId}"]`);
			$trigger.attr("aria-expanded", "true").removeClass("collapsed");
			$(`#${panelId}`)
				.removeAttr("style")
				.addClass("in")
				.removeClass("collapse");
		},
	},

	tasks: {
		init: () => {
			pp.viewHelpers.replaceTriggerTextOnDropdown($(".j-phases-dropdown"));
			if (window.location.hash) {
				// Load the correct tab if this page has been loaded with a hash
				setTimeout(() => {
					// Wait a bit, loading the tab immediately will kill bootstrap's fade animation
					const $panel = $(window.location.hash);
					if (!$panel.length) {
						return;
					}
					// Reset the uncollapse state of any .TaskPanel (usually the first panel is uncollapsed per default)
					$(".TaskPanel .TaskPanel__heading__collapse-link").addClass(
						"collapsed",
					);
					$(".TaskPanel .panel-collapse").removeClass("in");
					const $panelContainer = $panel.closest("article.tab-pane.fade");
					if (!$panelContainer.hasClass("active")) {
						$(`a[href=#'${$panelContainer.attr("id")}']`).trigger("click");
					}
					// Open the panel
					$panel.find("a").trigger("click");
				}, 250);
			}

			// Trigger autosize for newly visible textareas
			$('.j-task-top-nav a[data-toggle="tab"]').on("shown.bs.tab", function () {
				// @ts-expect-error
				$($(this).attr("href")).find("textarea:visible").autosize();
				pp.tasks.normalizeTasksTabHeights();
			});
			$(".Module--my-tasks div.panel-collapse.collapse").on(
				"shown.bs.collapse",
				function () {
					pp.viewHelpers.scrollToElement($(this).closest(".TaskPanel"));
				},
			);

			$(document).on(
				"bootstrap:breakpoint-changed",
				pp.tasks.normalizeTasksTabHeights,
			);
			// class can also be found in _answer_fields partial
			$("body").ready(() => {
				pp.viewHelpers.confirmTextPresent();
			});
			// @ts-expect-error
			$("a.j-popover-link").popover({
				container: "body",
				content: I18n.t("tasks.tasks_belong_to_a_later_phase"),
				placement: "bottom",
				trigger: "hover",
			});
			// @ts-expect-error
			$("a[id^='j-task-evaluation-tab'][data-toggle='null']").popover({
				container: "body",
				placement: "bottom",
				trigger: "hover",
			});

			// Sync with the phases-overview module if it's present.
			$(".Module--my-tasks nav a").on("click", function (event) {
				// Detect whether this was triggered by the user
				if (!event.originalEvent) {
					return;
				}
				// @ts-expect-error
				const targetPhaseId = $(this).attr("href").split("-")[1];
				const $targetNavItem = $(
					`.Module--phases-overview div.m-cyclic-nav-item[data-phase-id='${targetPhaseId}']`,
				);

				if (!$targetNavItem.is(":visible")) {
					// @ts-expect-error
					$("#phase-nav-carousel").carousel(
						$("#phase-nav-carousel div.m-cyclic-nav-set").index(
							$targetNavItem.parent(),
						),
					);
				}
				$targetNavItem.trigger("click");
			});

			// @ts-expect-error
			$(".Module--my-tasks .j-countdown-progress-dial").knob({
				min: 0,
				max: 1000,
				fgColor: "#179EE3",
				displayInput: false,
				width: 70,
				height: 70,
				thickness: 0.15,
				linecap: "round",
				readOnly: true,
				rotation:
					I18n.t("meta.direction") === "rtl" ? "clockwise" : "anticlockwise",
			});

			// Set internal links (to the information page etc.) to use AJAX
			$(
				".TaskPanel__body .rtf-content a[href^='../'], .TaskPanel__body .rtf-content a[href^='/']",
			).each((_index, elem) => {
				const $link = $(elem);
				$(elem).attr("data-remote", "true");
				// @ts-expect-error
				if (!$link.attr("href").includes("#")) {
					return; // `continue`
				}
				// Hashes are not preserved in remote (AJAX) requests, so also add them as URL params.
				// The param will be detected in `tabifyEls` and converted into a hash
				// @ts-expect-error
				const hrefParts = $link.attr("href").split("#");
				hrefParts.splice(1, 0, `?anchor=${hrefParts[1]}`);
				hrefParts[2] = `#${hrefParts[2]}`;
				$link.attr("href", hrefParts.join(""));
			});
		},

		normalizeTasksTabHeights: () => {
			$("div.j-normalize-tab-height:visible").each((_idx, container) => {
				const $container = $(container);
				const $taskLeftTabs = $container.find(
					"> .j-task-panel-body-left > .tab-content",
				);
				const $taskRightTabs = $container.find(
					"> .j-task-panel-body-right > .tab-content",
				);
				pp.viewHelpers.normalizeContainerHeights($taskLeftTabs);
				pp.viewHelpers.normalizeContainerHeights($taskRightTabs);
			});
		},

		toggleActorTaskCompleted: (
			actorTaskId,
			isCompleted,
			taskPhaseId,
			completenessStateString,
		) => {
			const $toggleEl = $(
				`.Task__completeness-toggle[data-actor-task-id=${actorTaskId}]`,
			);
			$toggleEl[isCompleted ? "addClass" : "removeClass"](
				"Task__completeness-toggle--completed",
			);

			const taskIsInCurrentPhase = pp.gameState.phaseId === taskPhaseId;
			let completedCountSelectors = [
				`.Module--phases-overview #j-phase-${taskPhaseId}`,
			];
			if (taskIsInCurrentPhase) {
				completedCountSelectors = completedCountSelectors.concat([
					".navbar-countdown-and-tasks",
					".Sticky-button--tasks",
				]);
			}
			const $completedSpans = $(
				completedCountSelectors
					.map((selector) => `${selector} .j-completed-tasks`)
					.join(", "),
			);

			let currentCompletedCount = parseInt($completedSpans.first().text(), 10);
			if (isCompleted) {
				currentCompletedCount += 1;
				if (taskIsInCurrentPhase) {
					pp.stickyButtons.setHighlightHelper(
						$(".Sticky-button--tasks"),
						"Sticky-button--highlight-green",
						"completedTasksHightlightTimeout",
					);
				}
			} else {
				currentCompletedCount -= 1;
			}
			// @ts-expect-error
			$completedSpans.html(currentCompletedCount);
			$toggleEl
				.parents(".OverlayContainer")
				.find(".OverlayContainer__content")
				.html(completenessStateString);
			// For the popover of the answer fields submit button
			$(
				`.j-actor-task-send-button[data-actor-task-id='${actorTaskId}']`,
				// @ts-expect-error
			).popover();
		},

		updateAnswerfields: (actorTaskId, isCompleted, answerFieldsHtml) => {
			const $actorTaskPanel = $(`#actor-task-${actorTaskId}-panel`);
			$actorTaskPanel
				.find("div.j-answer-fields")
				.first()
				.replaceWith(answerFieldsHtml);
			$actorTaskPanel
				.find("div.j-answer-fields")
				.first()
				.find("textarea")
				// @ts-expect-error
				.autosize();
			if (isCompleted) {
				$actorTaskPanel
					.find(".j-actor-task-send-button")
					.first()
					.addClass("completed");
				$(
					`button[data-actor-task-id=${actorTaskId}][data-confirm-text-present-target-selector]`,
				).removeAttr("data-confirm");
			} else {
				$actorTaskPanel
					.find("button.j-actor-task-send-button")
					.first()
					.removeClass("completed");
				pp.viewHelpers.confirmTextPresent(
					`button[data-actor-task-id=${actorTaskId}][data-confirm-text-present-target-selector]`,
				);
			}
		},
	},

	drafts: {
		openDraftTabInArticleWithMeasures: (draftPath) => {
			// Always mark the Draft link as active, it won't be done by the erb template
			const $draftLinks = $(`a[href='${draftPath}']`);
			$draftLinks.each((_index, draftLink) => {
				$(draftLink)
					.parent(".Nav__elem")
					.siblings(":not(.dropdown)")
					.removeClass("active");
				$(draftLink).parent(".Nav__elem").addClass("active");
				$(draftLink)
					.closest(".Nav__elem.dropdown")
					.siblings()
					.removeClass("active");
				$(draftLink).closest(".Nav__elem.dropdown").addClass("active");
			});
			if ($("#active-vote").hasClass("in")) {
				return;
			}
			$("#active-vote").siblings().removeClass("in active");
			$("#active-vote").addClass("in active");
		},

		// NB must provide `disableSubmitButtonPopoverContent` as an argument, it can#t be translated via I18n-js because the content is in the customizable_worindg
		observeChildrenOfArticleIterationsDropdown: (
			disableSubmitButtonPopoverContent,
		) => {
			const $dropdownElements = $(".j-article-iterations-menu");
			$dropdownElements.each((_index, dropdownElem) => {
				const observer = new MutationObserver((mutations) => {
					mutations.forEach(({ type, target }) => {
						const $target = $(target);
						if (type !== "childList" || !$target.is("ul.dropdown-menu")) {
							return;
						}
						const articleId = $(dropdownElem).attr("data-for-article-id");

						$(`.Nav__elem[data-for-article-id='${articleId}']`).attr(
							"data-open-drafts",
							$target.children("li.Draft--nav--state-unsubmitted").length,
						);
						$(`.Nav__elem[data-for-article-id='${articleId}']`).attr(
							"data-total-drafts",
							$target.children().length,
						);

						// Disable the submit buttons if the maximum allowed number of simultaneously undecided Drafts (`max_undecided_drafts`) has been reached.
						// Otherwise enable the button again, if the user does otherwise have the power to submit a Draft
						const $submitButtons = $(
							`.Draft__form button[type='submit'], .MeasuresList[data-for-article-id='${articleId}'] .Measure__call-vote-button`,
						);
						$submitButtons.each((_index, button) => {
							const $submitButton = $(button);
							// `data-submit-principally-allowed` is for normmal Drafts with text, `data-creation-principally-allowed` is for Drafts with Measures
							if (
								$submitButton.attr("data-submit-principally-allowed") !==
									"true" &&
								$submitButton.attr("data-creation-principally-allowed") !==
									"true"
							) {
								return; // `continue` for jQuery
							}
							const undecidedDraftsSize =
								$target.children("li.Draft--nav--state-pending").length +
								$target.children("li.Draft--nav--state-passed_tentatively")
									.length;
							const disableButton =
								undecidedDraftsSize >=
								parseInt(
									// @ts-expect-error
									$(`.Nav__elem[data-for-article-id='${articleId}']`).attr(
										"data-max-undecided-drafts",
									),
									10,
								);
							$submitButton.prop("disabled", disableButton);
							$submitButton[disableButton ? "addClass" : "removeClass"](
								"disabled",
							);
							if (disableButton) {
								// @ts-expect-error
								$submitButton.popover({
									content: disableSubmitButtonPopoverContent,
									placement: "bottom",
									trigger: "hover",
								});
							} else {
								// @ts-expect-error
								$submitButton.popover("destroy");
							}
						});

						if ($("#own-measures").length) {
							pp.measures.updateDisplayValues("#own-measures");
						}
					});
				});
				observer.observe(dropdownElem, {
					subtree: true,
					childList: true,
				});
			});
		},
	},

	// could handle Actor.signup_token und GameToken.token
	tokens: {
		gameTokenStatusForRegisterForm: [
			"available_lobby_for_registered_users",
			"available_single_actor",
			"available_for_activation",
		],

		behaviorPerState: {
			enable: () => {
				pp.tokens.$btn.prop("disabled", false);
				// NB this will only change the visible label for the button in _enter_token_form because in _register_form and _login_form the button is a `input` which does not have `text`
				pp.tokens.$btn.text(I18n.t("users.enter_game"));
				// Auto trigger the button once the user accepts the TOS if the token has been autofilled
				if (
					pp.tokens.tosCheckboxPass() &&
					pp.tokens.autofilledContent === pp.tokens.$inputField.val() &&
					(!pp.tokens.$userNameInput.length ||
						!pp.tokens.$userNameInput.is(":visible"))
				) {
					pp.tokens.$btn.trigger("click"); // Triggering a form submit won't disable the button with its data-disable-with attribute
				}
			},
			checkState: () => {
				pp.tokens.$btn.prop("disabled", true);
				if (!pp.tokens.$btn.hasClass("j-valid-code")) {
					pp.tokens.$btn.text(I18n.t("users.waiting_for_game_token"));
				} else if (!pp.tokens.tosCheckboxPass()) {
					pp.tokens.$btn.text(I18n.t("users.please_check_above_box"));
				} else if (pp.tokens.userNameInputPass()) {
					// @ts-expect-error
					ClientSideValidations.formBuilders["SimpleForm::FormBuilder"].remove(
						pp.tokens.$userNameInput,
						pp.tokens.clientSideValidationsFormSettings,
					);
					pp.tokens.behaviorPerState.enable();
				} else {
					pp.tokens.$btn.text(I18n.t("users.enter_game"));
				}
			},
			disable: () => {
				pp.tokens.$btn.removeClass("j-valid-code");
				pp.tokens.$btn.prop("disabled", true);
				pp.tokens.$btn.text(I18n.t("users.waiting_for_game_token"));
			},
			loading: () => {
				pp.tokens.$btn.removeClass("j-valid-code");
				pp.tokens.$btn.text(I18n.t("users.checking_game_token"));

				pp.tokens.setFormClass("FormWithToken--loading");
			},
		},

		getTokenStatus: (token, callbackFunction) => {
			$.get(`/game_tokens/${token}/check_status`, (result) => {
				callbackFunction(result);
				return;
			}).fail((_err) => {
				// Should never happen
				callbackFunction({ status_code: "forbidden" });
			});
		},

		tosCheckboxPass: () => {
			return (
				!pp.tokens.$tosCheckbox.length ||
				!pp.tokens.$tosCheckbox.is(":visible") ||
				pp.tokens.$tosCheckbox.prop("checked")
			);
		},

		userNameInputPass: () => {
			return (
				!pp.tokens.$userNameInput.length ||
				!pp.tokens.$userNameInput.is(":visible") ||
				pp.tokens.$userNameInput.val().length >= 3
			);
		},

		initRegisterForm: () => {
			pp.tokens.initRegisterFormTokenObserver();
			$(".RegisterForm").validate(); // Is only necessary when the form has been hidden before (on /start)
			// No need for `format_invalid` here, the form validator itself will deal with that case
			pp.users.initRegisterEmailObserver(
				$(".RegisterForm input[name='user[email]']"),
				["email_taken", "domain_inexistant", "forbidden"],
			);
			pp.global.initSelect2For($(".RegisterForm").find("select"));
		},

		initRegisterFormTokenObserver: () => {
			Object.assign(pp.tokens, {
				$inputField: $(".RegisterForm__token"),
				$tosCheckbox: $(".RegisterForm__tos-checkbox"),
				$btn: $(".RegisterForm input[type='submit']"),
			});
			pp.tokens.clientSideValidationsFormSettings = $(".RegisterForm").data(
				"clientSideValidations",
			).html_settings;

			const tokenStatusCallback = (result) => {
				if (
					[
						"forbidden",
						"game_not_started",
						"game_ended",
						"lobby_full",
						"token_redeemed",
					].includes(result.status_code)
				) {
					// @ts-expect-error
					ClientSideValidations.formBuilders["SimpleForm::FormBuilder"].add(
						pp.tokens.$inputField,
						pp.tokens.clientSideValidationsFormSettings,
						result.message,
					);
					pp.tokens.$inputField.disableClientSideValidations(); // Let the error label stay under the field
					pp.tokens.setFormClass("FormWithToken--forbidden");
					pp.tokens.behaviorPerState.disable();
					return;
				}
				// Redirect to /start if the status code indicates that the given token is not to be used in the Users register form,
				// e.g. if it's 'available_group' or 'available_single_actor_in_game_series_with_autogen_users'
				if (
					!pp.tokens.gameTokenStatusForRegisterForm.includes(result.status_code)
				) {
					if ($(".TokenForm").length) {
						// @ts-expect-error
						$("#login-carousel").carousel("prev");
						// Transfer to other form
						$(".TokenForm__token").val(pp.tokens.$inputField.val());
					} else {
						Turbolinks.visit(
							`/start?game_token=${pp.tokens.$inputField.val()}`,
						);
					}
				}
				// Else
				// @ts-expect-error
				ClientSideValidations.formBuilders["SimpleForm::FormBuilder"].remove(
					pp.tokens.$inputField,
					pp.tokens.clientSideValidationsFormSettings,
				);
				pp.tokens.setFormClass("FormWithToken--enabled");
				pp.tokens.behaviorPerState.enable();
			};

			pp.tokens.$inputField.off("input paste"); // In case there was a listener before
			pp.viewHelpers.setInputFieldChangeListener(
				pp.tokens.$inputField,
				(event) => {
					const $target = $(event.currentTarget);
					let val = $target.val();
					val = val.trim().replace(/[^a-z0-9]/gi, ""); // Cut non-alphanumeric characters
					$target.val(val);
					if (val.length >= 4) {
						pp.tokens.setFormClass("FormWithToken--loading");
						pp.tokens.getTokenStatus(val, tokenStatusCallback);
					} else {
						pp.tokens.setFormClass("FormWithToken--pending");
					}
				},
			);
			// Trigger once now
			if (pp.tokens.$inputField.val().length) {
				pp.tokens.$inputField.trigger("input");
			}
		},

		initJoinGameObserver: (autofilledContent) => {
			// pp.log("into initJoinGameObserver");
			Object.assign(pp.tokens, {
				$btn: $(".TokenForm__submit-button"),
				$tosCheckbox: $(".TokenForm__tos-checkbox"),
				$userNameInput: $(".j-user-name"),
				autofilledContent: autofilledContent,
				$inputField: $(".TokenForm__token"),
				$form: $(".TokenForm"),
				clientSideValidationsFormSettings: $(".TokenForm").data(
					"clientSideValidations",
				).html_settings,
			});

			pp.tokens.$form.data("clientSideValidations").validators[
				"join_game[user_name]"
			] = pp.viewHelpers.clientSideValidatorsFor("user", "name");

			const tokenStatusCallback = (result) => {
				pp.tokens.$tosCheckbox
					.closest(".form-group")
					[result.omit_tos_field ? "addClass" : "removeClass"]("hidden");
				pp.tokens.$userNameInput
					.closest(".form-group")
					[
						result.status_code === "available_lobby_for_autogen_users"
							? "removeClass"
							: "addClass"
					]("hidden");
				pp.tokens.$form.validate(); // Need to invoke this again for the custom validator to work
				// Redirect to /register if the status code indicates that the given Game Token is to be used in the Users register form
				if (
					pp.tokens.gameTokenStatusForRegisterForm.includes(
						result.status_code,
					) &&
					$(".TokenForm").length
				) {
					const redirectUrl = $(".TokenForm").attr("data-redirect-url") || "";
					// Redirect if explicit redirect url or if we're not on a page with the `.RegisterForm` (i.e. not on /start)
					if (redirectUrl.length || !$(".RegisterForm").length) {
						Turbolinks.visit(
							`${redirectUrl}/register?signup_key=${pp.tokens.$inputField.val()}`,
						);
					} else {
						const tokenVal = pp.tokens.$inputField.val();
						pp.tokens.$inputField.val(""); // Reset the field
						// @ts-expect-error
						$("#login-carousel").carousel("next");
						// Transfer to other form
						$(".RegisterForm__token").val(tokenVal);
					}
				}
				// Can be available_single_actor, available_actor_for_game_token, available_single_actor_in_game_series_with_autogen_users,
				// available_group, available_user, available_lobby_for_registered_users, available_lobby_for_autogen_users
				else if (result.status_code.startsWith("available")) {
					pp.tokens.$btn.addClass("j-valid-code");
					pp.tokens.setFormClass("FormWithToken--enabled");

					// Re-enable in case it was disabled below (will only activate the validator for 'presence')
					pp.tokens.$inputField.enableClientSideValidations();
					pp.tokens.behaviorPerState.checkState();
				} else if (result.status_code === "fail") {
					pp.tokens.behaviorPerState.disable();
				} else {
					pp.tokens.behaviorPerState.disable();
					pp.tokens.setFormClass("FormWithToken--forbidden");
					// @ts-expect-error
					ClientSideValidations.formBuilders["SimpleForm::FormBuilder"].add(
						pp.tokens.$inputField,
						pp.tokens.clientSideValidationsFormSettings,
						result.message,
					);
					pp.tokens.$inputField.disableClientSideValidations(); // Let the error label stay under the field
				}
			};

			pp.tokens.$inputField.off("input paste"); // In case there was a listener before
			pp.viewHelpers.setInputFieldChangeListener(
				pp.tokens.$inputField,
				(event) => {
					// @ts-expect-error
					ClientSideValidations.formBuilders["SimpleForm::FormBuilder"].remove(
						pp.tokens.$inputField,
						pp.tokens.clientSideValidationsFormSettings,
					);
					const $target = $(event.currentTarget);
					let val = $target.val();
					val = val.trim().replace(/[^a-z0-9]/gi, ""); // Cut non-alphanumeric characters
					$target.val(val);
					if (val.length >= 4) {
						pp.tokens.behaviorPerState.loading();
						pp.tokens.getTokenStatus(val, tokenStatusCallback);
					} else {
						pp.tokens.behaviorPerState.disable();
						pp.tokens.setFormClass("FormWithToken--pending");
					}
				},
			);

			pp.tokens.$inputField.on("focus blur", () => {
				$(".modal-fullscreen-image").toggleClass("hide-small");
			});
			if (pp.tokens.$tosCheckbox.length) {
				pp.tokens.$tosCheckbox.on(
					"click",
					pp.tokens.behaviorPerState.checkState,
				);
			}
			if (pp.tokens.$userNameInput.length) {
				pp.tokens.$userNameInput.on(
					"input",
					pp.tokens.behaviorPerState.checkState,
				);
			}

			if (pp.tokens.$inputField.val() !== "") {
				pp.tokens.$inputField.trigger("input");
			}
		},

		setFormClass: (className) => {
			pp.tokens.$inputField
				.closest(".FormWithToken")
				.removeClass((_index, classNames) => {
					return classNames
						.split(" ")
						.filter((className) => className.indexOf("FormWithToken--") !== -1)
						.join(" ");
				})
				.addClass(className);
		},
	},

	users: {
		// NB `email_taken_by_different_role` will only be returned if `roleConstraint` is provided
		initRegisterEmailObserver: (
			$target,
			statusCodesToCheck = [
				"email_taken",
				"email_taken_by_different_role",
				"domain_inexistant",
				"format_invalid",
				"forbidden",
			],
			roleConstraint,
		) => {
			const fieldChangeCallback = (event) => {
				const $target = $(event.currentTarget);
				if (
					!$target
						.data("changed", true)
						// @ts-expect-error
						.isValid(
							event.currentTarget.form.ClientSideValidations.settings
								.validators,
						)
				) {
					return; // Don't ask the server whether the email exists if the format is not valid
				}

				const signupStatusCallback = (result) => {
					// NB This is a callback within a callback
					if (statusCodesToCheck.includes(result.status_code)) {
						switch (result.status_code) {
							case "email_taken":
								event.currentTarget.form.ClientSideValidations.addError(
									$target,
									`${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.messages.taken")}. ${I18n.t("users.flash.click_here_to_log_in")}.`,
								);
								// @ts-expect-error
								$target.disableClientSideValidations(); // Let the error label stay under the field
								break;

							case "email_taken_by_different_role": {
								let errorString;
								if (roleConstraint === "moderator") {
									// We have a super special error message for this case
									errorString = `${I18n.t("activerecord.attributes.game_token.moderator_email")} ${I18n.t("activerecord.errors.models.user.exists_but_does_not_have_whitelisted_mod_role")}`;
									if (result.games_of_user_names) {
										errorString += `<br>${I18n.t("activerecord.models.cloned_game.one")}: ${result.games_of_user_names}`;
									}
								} else {
									errorString = `${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.messages.taken")}.`;
								}
								event.currentTarget.form.ClientSideValidations.addError(
									$target,
									errorString,
								);
								// @ts-expect-error
								$target.disableClientSideValidations(); // Let the error label stay under the field
								break;
							}

							case "domain_inexistant":
								event.currentTarget.form.ClientSideValidations.addError(
									$target,
									`${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.messages.invalid")}.`,
								);
								// @ts-expect-error
								$target.disableClientSideValidations(); // Let the error label stay under the field
								$target.one("input", (_event) => {
									// Only 'input', not 'change', to make sure that the user actually changed the content
									// @ts-expect-error
									$target.enableClientSideValidations();
								});
								break;

							case "format_invalid":
								event.currentTarget.form.ClientSideValidations.addError(
									$target,
									`${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.messages.invalid")}.`,
								);
								// @ts-expect-error
								$target.disableClientSideValidations(); // Let the error label stay under the field
								$target.one("input", () => {
									// Only 'input', not 'change', to make sure that the user actually changed the content
									// @ts-expect-error
									$target.enableClientSideValidations();
								});
								break;

							case "forbidden":
								event.currentTarget.form.ClientSideValidations.addError(
									$target,
									`${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.messages.exclusion")}.`,
								);
								// @ts-expect-error
								$target.disableClientSideValidations(); // Let the error label stay under the field
								$target.one("input", () => {
									// Only 'input', not 'change', to make sure that the user actually changed the content
									// @ts-expect-error
									$target.enableClientSideValidations();
								});
								break;
						}
					}
				};

				pp.users.checkUserEmailRemotely($target, signupStatusCallback, {
					whitelisted_role: roleConstraint,
				});
			};
			$target.off("input paste"); // In case there was a listener before
			pp.viewHelpers.setInputFieldChangeListener($target, fieldChangeCallback);
		},

		checkUserEmailRemotely: async ($target, callback, optionsHash) => {
			optionsHash = optionsHash || {};
			const whitelistedRole = optionsHash.whitelisted_role;
			const roleBlacklist = optionsHash.role_blacklist;
			const params = new URLSearchParams({ email: $target.val() });
			if (whitelistedRole !== undefined) {
				params.set("whitelisted_role", whitelistedRole);
			} else if (roleBlacklist !== undefined) {
				params.set("role_blacklist", JSON.stringify(roleBlacklist));
			}
			const response = await fetch(`/users/check_email?${params}`);
			callback(await response.json());
		},

		checkUserEmailWithRoleConditions: (event, roleConditionsHash) => {
			const $target = $(event.currentTarget);
			const $addUserform = $target.closest("form");
			const conditionIsForWhitelist =
				Object.keys(roleConditionsHash)[0] === "whitelisted_role"; // Else is for 'role_blacklist'
			// Default to sending a generic password (this input field does not exist in all forms from which checkUserEmailWithRoleConditions is called!)
			// @ts-expect-error
			$addUserform.find("input[name='user[send_generic_password]']").val(true);
			const signupStatusCallback = (result) => {
				const clientSideValidationsInstance =
					// @ts-expect-error
					$addUserform[0].ClientSideValidations;

				// pp.log("checkUserEmailWithRoleConditions:", conditionIsForWhitelist, result)
				if (result.status_code === "format_invalid") {
					$addUserform
						.find("input[type='submit']")
						.prop("disabled", true)
						.addClass("disabled");
					clientSideValidationsInstance.addError(
						$target,
						`${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.messages.invalid")}.`,
					);
					// @ts-expect-error
					$target.disableClientSideValidations(); // Let the error label stay under the field
				} else if (conditionIsForWhitelist) {
					const roleConstraint = Object.values(roleConditionsHash)[0];
					switch (result.status_code) {
						case "email_taken":
						case "email_available":
							$addUserform
								.find("input[type='submit']")
								.prop("disabled", false)
								.removeClass("disabled");
							clientSideValidationsInstance.removeError($target);
							break;

						case "domain_inexistant":
							$addUserform
								.find("input[type='submit']")
								.prop("disabled", true)
								.addClass("disabled");
							// Having to disable the submit button should not be necessary because `addError` should take care of it, but somehow doesn't
							clientSideValidationsInstance.addError(
								$target,
								I18n.t("activerecord.errors.models.user.domain_inexistant"),
							);
							// @ts-expect-error
							$target.disableClientSideValidations();
							break;

						case "email_taken_by_different_role": {
							let errorString;
							if (roleConstraint === "moderator") {
								// We have a super special error message for this case
								errorString = `${I18n.t("activerecord.attributes.game_token.moderator_email")} ${I18n.t("activerecord.errors.models.user.exists_but_does_not_have_whitelisted_mod_role")}`;
								if (result.games_of_user_names) {
									errorString += `<br>${I18n.t("activerecord.models.cloned_game.one")}: ${result.games_of_user_names}`;
								}
							} else {
								errorString = `${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.messages.taken")}.`;
							}
							clientSideValidationsInstance.addError($target, errorString);
							// @ts-expect-error
							$target.disableClientSideValidations(); // Let the error label stay under the field
							break;
						}
					}
				} else {
					switch (result.status_code) {
						case "email_taken_without_blacklisted_role":
						case "email_available":
							$addUserform
								.find("input[type='submit']")
								.prop("disabled", false)
								.removeClass("disabled");
							clientSideValidationsInstance.removeError($target);
							if (
								result.status_code === "email_taken_without_blacklisted_role"
							) {
								$("#j-user-already-exists-warning").removeClass("hidden");
								// No need to send a generic password
								$addUserform
									.find("input[name='user[send_generic_password]']")
									// @ts-expect-error
									.val(false);
							} else {
								// i.e. is 'email_available'
								$("#j-user-already-exists-warning").addClass("hidden");
							}
							break;

						default:
							$addUserform
								.find("input[type='submit']")
								.prop("disabled", true)
								.addClass("disabled");
							$("#j-user-already-exists-warning").addClass("hidden");
							if ("email_taken_by_different_role" === result.status_code) {
								clientSideValidationsInstance.addError(
									$target,
									`${I18n.t("activerecord.models.user.one")} ${I18n.t("activerecord.errors.models.user.has_blacklisted_role_admin_manager_or_mod")}`,
								);
								// @ts-expect-error
								$target.disableClientSideValidations();
							} else if ("domain_inexistant" === result.status_code) {
								clientSideValidationsInstance.addError(
									$target,
									I18n.t("activerecord.errors.models.user.domain_inexistant"),
								);
								// @ts-expect-error
								$target.disableClientSideValidations();
							} else if ("email_taken" === result.status_code) {
								clientSideValidationsInstance.addError(
									$target,
									`${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.messages.taken")}`,
								);
								// @ts-expect-error
								$target.disableClientSideValidations();
							}
					}
				}
			};
			pp.users.checkUserEmailRemotely(
				$target,
				signupStatusCallback,
				roleConditionsHash,
			);
		},

		initPasswordVisibilityToggle: (toggleSelector) => {
			const $toggle = $(toggleSelector);
			$toggle.on("click", (_event) => {
				const $passwordField = $toggle.closest(".form-group").find("input");
				if ($passwordField.attr("type") === "password") {
					$toggle.addClass("active focus");
					$passwordField.attr("type", "text");
				} else {
					$toggle.removeClass("active focus");
					$passwordField.attr("type", "password");
				}
			});
		},
	},

	instructionSlides: {
		addButtonFor: (route, slidesReadStatus, buttonTranslationString) => {
			pp.log(
				"INSTRUCTION SLIDES add button for instructions -- route, slides read status, button container selector, button translation string",
				route,
				slidesReadStatus,
				buttonTranslationString,
			);

			// check if the modal has already been initialized (.one() get's triggered more than once in resolutions#committee/resolutions#plenary for some reason)
			// also check if the route is empty (the helper returns an empty string if there are no instructions)
			if ($("#instruction-modal").data("route") === route || route === "") {
				return;
			}
			let $buttonContainer = $(".j-instructions-button-container:visible");
			if (!$buttonContainer.length) {
				$buttonContainer = $(".j-instructions-button-container");
			}

			$("#instruction-modal").data("route", route);
			// Empty this so that `handleModalButtonClick` won't return immediately
			$("#j-instruction-carousel .carousel-indicators").html("");
			if (!$buttonContainer.children("button").length) {
				// @ts-expect-error
				$buttonContainer[0].innerHTML += `<button id='instructions-modal-button'
						href='javascript:;'
						data-target='#instruction-modal'
						data-toggle='modal'
						class='button btn-primary hidden-below-grid-breakpoint${slidesReadStatus === "read_all_slides" ? " read-all" : ""}'>
						${I18n.t(buttonTranslationString)}
					</button>`;
			}
			$("#instructions-modal-button").one("destroyed destroyed_proxy", () => {
				$("#instruction-modal").data("route", "");
			});

			$("#instructions-modal-button")
				.off("click")
				.on("click", pp.instructionSlides.handleModalButtonClick);

			// mark button as read or open modal if it has never been opened
			if (slidesReadStatus === "unread") {
				$("#instructions-modal-button").trigger("click");
			}
		},

		handleModalButtonClick: () => {
			// pp.log("INSTRUCTION SLIDES handle modal button click");
			if (
				$("#j-instruction-carousel").find(".carousel-indicators").children()
					.length
			) {
				// No need to reload anything
				return;
			}
			const route = $("#instruction-modal").data("route");
			const readAll = $("#instructions-modal-button").hasClass("read-all");

			$.get(
				`/games/page_instruction_slides?route=${encodeURIComponent(route)}`,
				(data) => {
					$("#instruction-modal").find(".carousel-indicators").html("");
					$("#instruction-modal").find(".carousel-inner").html("");
					pp.modals.populateMenuModal($("#instruction-modal"), data);

					// Hide carousel slide buttons if there is only one slide (always to this)
					if ($("#j-instruction-carousel div.item").length === 1) {
						$("#instruction-modal").find("div.carousel-nav").hide();

						// Immediately mark button if there is only one slide
						if (!readAll) {
							pp.instructionSlides.trackSlideReadStatus("read_all_slides");
						}
					} else {
						// In case it was hidden before
						$("#instruction-modal").find("div.carousel-nav").show();

						// listen for the carousel to slide to the last page
						const lastSlide = $("#j-instruction-carousel div.item")
							.last()
							.get(0);
						$("#j-instruction-carousel")
							.off("slide.bs.carousel")
							.on("slide.bs.carousel", (e) => {
								$("#instruction-modal .title-nav li").removeClass("active");
								// @ts-expect-error
								const relatedTarget = $(e.relatedTarget).get(0);
								const slideIdx = $("#j-instruction-carousel div.item").index(
									relatedTarget,
								);
								// @ts-expect-error
								$($("#instruction-modal .title-nav li").get(slideIdx)).addClass(
									"active",
								);
								if (!readAll && relatedTarget === lastSlide) {
									pp.instructionSlides.trackSlideReadStatus("read_all_slides");
								}
							});
					}
				},
			);

			if (!readAll) {
				pp.instructionSlides.trackSlideReadStatus("opened_slides");
			}
		},

		trackSlideReadStatus: (trackAction) => {
			pp.log(
				"INSTRUCTION SLIDES track slide read status -- trackAction",
				trackAction,
			);
			$.post("/activities/save_tracked_information", {
				route: $("#instruction-modal").data("route"),
				track_action: trackAction,
			});

			if (trackAction === "read_all_slides") {
				$("#instructions-modal-button").addClass("read-all");
			}
		},
	},

	modals: {
		showGameSettingsModalWith: (contentHtml, headerText, formId) => {
			const $settingsModal = $("#game-settings-modal");
			$settingsModal.one("shown.bs.modal", () => {
				pp.global.initSelect2For($settingsModal.find("select:visible"));
				$(document).trigger("page:change");
			});
			$settingsModal.find(".modal-header h3").text(headerText);
			$settingsModal.find(".modal-body").html(contentHtml);

			const submitButtonText =
				$(`#${formId}`).attr("data-submit-button-text") ||
				I18n.t("global.actions.save");
			$settingsModal
				.find("#j-game-settings-modal-form-submit")
				.attr({ form: formId })
				// @ts-expect-error
				.attr("data-disable-with", submitButtonText)
				// @ts-expect-error
				.val(submitButtonText);
			$settingsModal.modal("show");
			pp.backend.formHelpers.convertFormHintsToPopovers();
			pp.viewHelpers.scrollToTop();
		},

		populateMenuModal: ($modal, dataHash) => {
			// pp.log("MODALS into populateMenuModal", $modal, dataHash);
			const $carouselMenu = $modal.find(".carousel-indicators").first(); // There might be multiple (i.e. also a .carousel-indicators--bottom)
			const carouselId = $modal.find(".carousel").attr("id");

			let overallSlidesCounter = $modal.find("li[data-slide-to]").length; // Also from the .carousel-indicators--bottom
			dataHash.forEach((slidesProperties) => {
				// pp.log("at entries", slidesProperties);
				slidesProperties.forEach((slideProperties, index) => {
					let classes = "";
					if (index > 0) {
						classes += "ext-padding-large-left";
					}
					if (slidesProperties[index].active === true) {
						classes += " active";
					}
					$carouselMenu.append(
						`<li data-target='#${carouselId}' data-kb-id='${slideProperties.id}' data-slide-to='${overallSlidesCounter}' class='${classes}'>${slideProperties.title}</li>`,
					);
					$modal
						.find(".carousel-inner")
						.append(`<div data-kb-id='${slideProperties.id}' class='item modal-body${slideProperties.active === true ? " active" : ""}'>
						<h2>${slideProperties.title}</h2>
						<div class='j-slide-content'>${slideProperties.html || ""}</div>
					</div>`);
					pp.knowledgeBase.observeLinkedModalSlideLinks(
						$modal.find(".item.modal-body").last(),
					);
					overallSlidesCounter += 1;
				});
			});
		},

		fetchLinkedModalSlide: (kbSlideId) => {
			const $modal = $(".modal.in");
			const $carouselMenu = $modal.find(".carousel-indicators").first(); // There might be multiple (i.e. also a .carousel-indicators--bottom)
			const carouselId = $modal.find(".carousel").attr("id");
			$modal
				.find(".item.modal-body.active, .carousel-indicators li.active")
				.removeClass("active");
			$.ajax({
				url: `/kb_modules/${kbSlideId}`,
				type: "GET",
				dataType: "json",
			})
				// @ts-expect-error
				.success((data) => {
					$carouselMenu.append(
						`<li class='active' data-target='#${carouselId}' data-kb-id='${kbSlideId}' data-slide-to='${$modal.find(".item.modal-body").length}'>${data.title}</li>`,
					);
					$modal
						.find(".carousel-inner")
						.append(`<div data-kb-id='${kbSlideId}' class='item modal-body active'>
					<h2>${data.title}</h2>
					<div class='j-slide-content'>${data.html}</div>
				</div>`);
					pp.knowledgeBase.observeLinkedModalSlideLinks(
						$modal.find(".item.modal-body.active"),
					);
				})
				.fail(() => {
					pp.log("MODALS fetchLinkedModalSlide failed");
				});
		},

		populateRemoteModal(modalSelector, modalBodyContent) {
			const $modal = $(modalSelector);
			let $targetEl = $modal.find(".modal-content");
			if ($modal.find(".modal-header").length) {
				$targetEl = $modal.find(".modal-body");
			}
			// pp.log("populating modal", $modal, $targetEl);
			$targetEl.html(modalBodyContent);
			$targetEl.find("time[data-time-ago]").timeago();
			pp.vue.mountElementsInContainer($targetEl);
			//The modal is loaded it will be live updated now.
			$(`[data-toggle="modal"][data-target="${modalSelector}"]`)
				.removeAttr("href")
				.removeAttr("data-remote");
		},

		fetchGameManualSlides: (event) => {
			const $modal = $("#game-manual-modal");
			// Remove content from previous requests
			$modal.find(".carousel-indicators").children().remove();
			$modal.find(".carousel-inner .item.modal-body").remove();
			$modal.find(".carousel-inner").children().removeClass("active");
			const gameId = $(event.relatedTarget).attr("data-game-id");
			$.ajax({
				url: "/games/manual_pages",
				type: "GET",
				dataType: "json",
				data: { game_id: gameId }, // Might be undefined
				// @ts-expect-error
			}).success((data) => {
				const $carouselMenu = $modal.find(".carousel-indicators");
				let totalDocuments = 0;
				$carouselMenu.removeClass((_index, classNames) => {
					// Remove old class name
					return (
						classNames.match(/carousel-indicators--documents-size-?\d*/g) || []
					).join(" ");
				});
				["preparation_document", "follow_up_document"].forEach((docType) => {
					if (data[docType]?.length) {
						totalDocuments += data[docType].length;
						data[docType].forEach(([linkHTML, fileName]) => {
							$carouselMenu.append(`<li class='carousel-indicators--bottom' title='${fileName}'>\
								<span class='glyphicon glyphicon-download'></span>\
								${linkHTML}\
							</li>`);
						});
					}
				});
				$carouselMenu.addClass(
					`carousel-indicators--documents-size-${totalDocuments}`,
				); // Add new class name
				if (data.manual_pages_data.length) {
					$modal.find(".lds-ring").remove();
					pp.modals.populateMenuModal($modal, data.manual_pages_data);
					const params = $.param({
						richtextable_scope: "manual_pages",
						game_id: gameId, // Nb will create an empty `&game_id=` URI component
					});
					$modal
						.find(".j-pdf-print-button")
						.attr("href", `/rtf_infos/print?${decodeURIComponent(params)}`)
						.show();
				} else {
					let fallbackSlideContent = "";
					// Attempt to populate one slide with the links to the attached documents if there are any
					["preparation_document", "follow_up_document"].forEach((docType) => {
						if (data[docType]?.length) {
							fallbackSlideContent += `<h4>${I18n.t(`activerecord.models.${docType}.other`)}</h4>`;
							data[docType].forEach(([linkHTML, _fileName]) => {
								fallbackSlideContent += `<p>${linkHTML}</p>`;
							});
						}
					});
					if (!fallbackSlideContent.length) {
						fallbackSlideContent = I18n.t("cms.utils.x_without_y", {
							x: I18n.t("activerecord.models.game", { count: 1 }),
							// @ts-expect-error
							y: I18n.t("activerecord.models.manual_page", { count: "other" }),
						});
					}
					$modal
						.find(".carousel-inner")
						.html(
							`<div class='item modal-body active'>${fallbackSlideContent}</div>`,
						);
					$modal.find(".j-pdf-print-button").hide();
				}
			});
		},
	},

	knowledgeBase: {
		fetchModalContent: (event) => {
			const $modal = $("#knowledge-base-modal");
			// Remove content from previous requests except the ("static") bottom content like FAQ and glossary
			$modal
				.find(".carousel-indicators")
				.children(":not(.carousel-indicators--bottom)")
				.remove();
			$modal.find(".carousel-indicators").children().removeClass("active");
			$modal.find(".carousel-inner .item.modal-body[data-kb-id]").remove();
			$modal
				.find(".carousel-inner")
				.children(":not(.j-to-remove)")
				.removeClass("active");

			const primedModuleRoute = $(event.relatedTarget).attr(
				"data-primed-module-route",
			); // Might be undefined
			const primedSlideId = $(event.relatedTarget).attr("data-primed-slide-id"); // Might be undefined
			const requestData = {};

			if (primedModuleRoute) {
				requestData.module_route = primedModuleRoute;
			} else {
				if (window.location.search.startsWith("?primed_for_kb_module_id")) {
					requestData.primed_module_id = window.location.search.split("=")[1];
					// @ts-expect-error
					window.history.pushState(null, null, window.location.pathname);
				} else {
					requestData.current_path = window.location.pathname;
				}
				requestData.module_names = $(".Module[data-kb-module-name]")
					.get()
					.map((moduleEl) => {
						return $(moduleEl).attr("data-kb-module-name");
					});
			}
			$.ajax({
				url: "/kb_modules",
				type: "GET",
				dataType: "json",
				data: requestData,
			})
				// @ts-expect-error
				.success((data) => {
					$modal.find(".carousel-inner .j-to-remove").remove();
					if (data.slides.length) {
						pp.modals.populateMenuModal($modal, data.slides);
						$modal
							.find(".kb-module-direct-link")
							.attr(
								"href",
								`//${window.location.host}/?primed_for_kb_module_id=${data.active_module_id}`,
							);
						// Only fetch the slide contenet when actually navigating to the slide
						$modal
							.find(".carousel-indicators li[data-kb-id]")
							.one("click", (event) => {
								const $linkEl = $(event.currentTarget);
								pp.knowledgeBase.populateSlide($linkEl.attr("data-kb-id"));
							});
						if (primedSlideId) {
							$modal
								.find(`.carousel-indicators li[data-kb-id='${primedSlideId}']`)
								.trigger("click");
						} else {
							$modal.find(".carousel-indicators li.active").trigger("click"); // Load the first slide
						}
						$("#j-kb-carousel")
							.off("slide.bs.carousel")
							.on("slide.bs.carousel", (event) => {
								pp.knowledgeBase.populateSlide(
									// @ts-expect-error
									$(event.relatedTarget).attr("data-kb-id"),
								);
							});
					} else if ($modal.find(".carousel-inner").children().length) {
						// No content for path - expect to have the FAQ and glossary elements
						// pp.log("got no content for requestData");
						$modal
							.find(".carousel-inner")
							.children()
							.first()
							.addClass("active");
						$modal
							.find(".carousel-indicators")
							.children()
							.first()
							.addClass("active");
					} else {
						$modal
							.find(".carousel-inner")
							.html(I18n.t("error_pages.not_found"));
					}
				})
				.fail(({ responseJSON }, statusCode, statusText) => {
					pp.log(
						"KNOWLEDGE BASE fetchModalContent failed",
						responseJSON,
						statusCode,
						statusText,
					);
					$modal
						.find(".modal-body.active")
						.html(responseJSON?.message ? responseJSON.message : statusText);
				});
		},

		populateSlide: (kbSlideId) => {
			// pp.log("KB into populateSlide", kbSlideId);
			const $slide = $(`div[data-kb-id='${kbSlideId}']`);
			if (
				$slide.find(".j-slide-content").html() !== "" ||
				$slide.attr("j-loading")
			) {
				// pp.log("- nothing to do");
				return;
			}
			// @ts-expect-error
			$slide.attr("j-loading", true);
			const callback = (data) => {
				$slide.find(".j-slide-content").html(data.html);
				pp.knowledgeBase.observeLinkedModalSlideLinks($slide);
			};
			pp.knowledgeBase.fetchSlideContent(kbSlideId, callback);
		},

		fetchSlideContent: (kbSlideId, callback) => {
			// pp.log("KB into fetchSlideContent", kbSlideId);
			$.ajax({
				url: `/kb_modules/${kbSlideId}`,
				type: "GET",
				dataType: "json",
			})
				// @ts-expect-error
				.success(callback)
				.fail(() => {
					pp.log("KNOWLEDGE BASE fetchSlideContent failed");
				});
		},

		observeLinkedModalSlideLinks: ($slide) => {
			$slide.find("a[data-kb-id]").on("click", (event) => {
				const moduleContentId = $(event.currentTarget).attr("data-kb-id");
				const $presentMenuItem = $slide
					.closest(".modal")
					.find(`.carousel-indicators li[data-kb-id='${moduleContentId}']`);
				if ($presentMenuItem.length) {
					$presentMenuItem.trigger("click");
				} else {
					pp.modals.fetchLinkedModalSlide(moduleContentId);
				}
				event.preventDefault(); // Necessary to avoid adding the anchor '#' to the browser's address bar
			});
		},

		fetchPopupContent: (event) => {
			pp.log("KB into fetchPopupContent", event);

			const $popoverLink = $(event.currentTarget);
			const moduleName = $popoverLink.data("moduleName");
			const $module = $(`.Module[data-kb-module-name='${moduleName}']`);
			// @ts-expect-error
			const $popoverContentToFill = $($popoverLink.attr("data-content"));

			if (bowser.safari) {
				$popoverLink.focus(); // Safari doesn't set the focus on an element that's being clicked  ㄟ( ▔, ▔ )ㄏ
			}
			$popoverLink.on("focusout", pp.knowledgeBase.dismissPopover);

			const callback = (data) => {
				// pp.log("KB fetchPopupContent -- into callback", data);
				// @ts-expect-error
				$popoverContentToFill.find(".j-popover-content-inner").html(data.html);
				// The popover gets populated from the `data-content` and `data-original-title` attributes every time the popover is opened,
				// so store the fetched data in this attribute to avoid having to fetch it every time
				// @ts-expect-error
				$popoverLink.attr("data-content", $popoverContentToFill.html());
				$module.find(".j-popover-title").text(data.title);
				$popoverLink.attr(
					"data-original-title",
					$module.find(".popover-title").html(),
				); // This contains the question mark icon + the title string
				$module.find(".popover-content").replaceWith($popoverContentToFill);
			};
			$.ajax({
				url: `/kb_modules/`,
				data: { for_overlay: true, module_names: [moduleName] },
				type: "GET",
				dataType: "json",
			})
				// @ts-expect-error
				.success((slideIds) => {
					slideIds.forEach((slideId) => {
						pp.knowledgeBase.fetchSlideContent(slideId, callback);
					});
					if (!slideIds.length) {
						$module.find(".j-popover-content-inner").html(
							I18n.t("global.no_child_for_parent_yet", {
								child_model_name: I18n.t("activerecord.models.kb_module", {
									// @ts-expect-error
									count: "other",
								}),
								parent_model_name: moduleName,
							}),
						);
					}
				})
				.fail(() => {
					pp.log("fetchPopupContent failed");
				});
		},

		dismissPopover: (event) => {
			// Can't use `focus` as the proper trigger because Safari doesn't trigger on focus for some reason
			$(event.currentTarget).trigger("click");
		},
	},

	unlockables: {
		addImageToMap: (
			imgUrl,
			unlockableNumber,
			phaseId,
			unlockableAnalysisPageCategoryId,
		) => {
			const $mapForPhase = $(`#map-phase-${phaseId}`);
			if (!$mapForPhase.length) {
				// pp.log("no map found");
				return;
			}
			if (
				$mapForPhase.find(
					`img[src*='${imgUrl}'][data-unlockable-number='${unlockableNumber}']`,
				).length
			) {
				// pp.log("already present");
				return;
			}
			imgUrl = imgUrl.substring(0, imgUrl.indexOf("?"));
			let $imgElem;
			if (unlockableAnalysisPageCategoryId !== undefined) {
				$imgElem = `<img src='${imgUrl}' data-unlockable-number='${unlockableNumber}' data-unlockable-analysis-page-category-id='${unlockableAnalysisPageCategoryId}' />`;
			} else {
				$imgElem = `<img src='${imgUrl}' data-unlockable-number='${unlockableNumber}' />`;
			}
			const $currentImages = $mapForPhase.find("img[data-unlockable-number]");
			const insertBeforeImage = $currentImages.filter((_index, imgEl) => {
				// @ts-expect-error
				return $(imgEl).attr("data-unlockable-number") > unlockableNumber;
			})[0];
			// @ts-expect-error
			if (insertBeforeImage?.length) {
				$(insertBeforeImage).before($imgElem);
			} else {
				$mapForPhase.find(".Base").after($imgElem);
			}
		},

		removeImageFromMap: (imgUrl, unlockableNumber, phaseId) => {
			const $mapForPhase = $(`#map-phase-${phaseId}`);
			if (!$mapForPhase.length) {
				// pp.log("no map found");
				return;
			}
			imgUrl = imgUrl.substring(0, imgUrl.indexOf("?"));
			const $elemToRemove = $mapForPhase.find(
				`img[src*='${imgUrl}'][data-unlockable-number='${unlockableNumber}']`,
			);
			$elemToRemove.remove();
		},
	},

	publications: {
		truncateFeedElemsWrapper: ($publicationElems) => {
			pp.publications.truncateFeedElems(
				$publicationElems.find(".Publication__content"),
			);
			pp.publications.truncateFeedElems(
				$publicationElems.find(".Publication__title"),
				48,
			);
		},

		truncateFeedElems: ($elems, height = 180) => {
			// pp.log("TRUNCATING publications idx", $elems, height);

			// Remove embeds, eventually replace with "media" image if embeds play a role in Publications
			$elems.find("iframe").remove();
			$elems.dotdotdot({
				/* The HTML to add as ellipsis. */
				ellipsis: "…",
				/* How to cut off the text/html: 'word'/'letter'/'children' */
				wrap: "letter",
				/* Whether to update the ellipsis: true/'window' */
				watch: false,
				lastCharacter: {
					remove: [" ", ",", ";", ".", "!", "?"],
				},
				height: height,
			});
		},

		initFeed: (publicationCategory) => {
			pp.publications[publicationCategory] = {};
			pp.publications[publicationCategory].$feed = $(
				`.PublicationsIndex--${publicationCategory}`,
			);
			pp.log(
				"into Publications initFeed -- elem",
				pp.publications[publicationCategory].$feed,
			);
			pp.global.autoloadPagination(pp.publications[publicationCategory].$feed);

			const $publicationFeedEls =
				pp.publications[publicationCategory].$feed.find(".Publication");
			if (pp.publications[publicationCategory].$feed.is(":visible")) {
				setTimeout(() => {
					// Give the images within `.Publication__content` a bit of time to load, otherwise `.dotdotdot` (above) will not work
					pp.publications.truncateFeedElemsWrapper($publicationFeedEls);
				}, 50);
			} else {
				// NB leave this at `.on`, not `.one`, so that dynamically inserted elements are being truncated whenn re-opening the tab pane
				// (Below ìnsertNode` listener will not properly invoke truncating elements that are inserted and in another visible tab pane.)
				$(
					`.j-publication-categories-menu a[href='#${publicationCategory}']`,
				).on("shown.bs.tab", () => {
					// pp.log("- showing tab", publicationCategory);
					setTimeout(() => {
						// Give the images within `.Publication__content` a bit of time to load, otherwise `.dotdotdot` (above) will not work
						pp.publications.truncateFeedElemsWrapper(
							pp.publications[publicationCategory].$feed.find(".Publication"),
						); // Need to reload the items
					}, 50);
				});
			}

			pp.publications[publicationCategory].$feed
				.observe()
				.on("insertNode", (_event, el) => {
					if (el.textContent.trim().length === 0 || el.tagName === "NAV") {
						return; // For some reason bootstrap inserts empty text nodes; don't do anything for the pagination elem
					}

					$(el).find("time[data-time-ago]").timeago();
					pp.publications.truncateFeedElemsWrapper($(el));
				});
		},

		initDropdownMenu: () => {
			$(".j-publication-categories-menu a").on("click", function () {
				var $elem = $(this);
				pp.viewHelpers.manageDropdownActiveState($elem);
				if ($elem.attr("href") === "#kweet") {
					pp.activities.queueActivitiesRead(
						$elem.parent().attr("data-unread-activity-ids"),
					);
				}
			});
			// Imeediately set Activities read for kwitter
			if (
				$(".j-publication-categories-menu li.active a").attr("href") ===
				"#kweet"
			) {
				setTimeout(() => {
					// Wait so that 'data-unread-activity-ids' can be set first
					pp.activities.queueActivitiesRead(
						$(".j-publication-categories-menu li.active").attr(
							"data-unread-activity-ids",
						),
					);
				}, 150);
			}
		},
	},

	actorActiveStatus: {
		neverLoggedInTimestamps: [
			"0000-01-01T00:00:00.000+00:00",
			"0000-01-01T00:00:00.000Z",
		],

		init: () => {
			pp.vue.bus.$on(
				"game-actors-UPDATE",
				pp.actorActiveStatus.updateActiveStatus,
			);
		},

		statusHtml: (isOnline, wentOfflineMostRecently) => {
			if (isOnline) {
				return I18n.t("global.online");
			} else if (
				pp.actorActiveStatus.neverLoggedInTimestamps.includes(
					wentOfflineMostRecently,
				)
			) {
				return I18n.t("global.first_login_pending");
			} else {
				return `<time class='timeago' datetime='${wentOfflineMostRecently}' data-time-ago='${wentOfflineMostRecently}'></time>`;
			}
		},

		updateActiveStatus: () => {
			const gameActors = VueStore.getters.gameActors();
			Object.entries(gameActors).forEach(([actorId, values]) => {
				// pp.log("at actor", actorId, values, values.wentOfflineMostRecently)
				const $statusEl = $(
					`.j-actor-active-status[data-status-actor-id="${actorId}"]`,
				);
				$statusEl.html(
					pp.actorActiveStatus.statusHtml(
						values.isOnline,
						values.wentOfflineMostRecently,
					),
				);
				$statusEl.find("time[data-time-ago]").timeago();
			});
		},
	},
};
